<div
  class="flex justify-between"
  [class.text-input-label-disabled]="control()?.disabled()"
>
  <div class="flex gap-1" [class.skeleton]="loading()">
    <ng-content select="label" />
    @if (control()?.required() && !loading()) {
    <span id="required" class="text-primary">*</span>
    }
  </div>
  @if (link()) {
  <a
    class="link-lg--default text-primary inline-block focus:outline-none"
    [class.skeleton]="loading()"
    [href]="$safeNavigationMigration(link()?.url)"
    [target]="link()?.target || '_blank'"
    >{{ link()?.text }}</a
  >
  }
</div>
<div id="tvd-control-container" [class.skeleton]="loading()">
  <ng-content select="tvdPrefix" />
  <ng-content />
  <ng-content select="tvdSuffix" />
</div>
